import { BetStatus } from '@pascal/pascal-core';

import { createGuid } from './createGuid';
import { divide } from './arithmeticOperations';

export const buildCurrentLiveBets = (userId, currentBets = []) => {
  const myBets = currentBets.filter((bet) => bet.userId === userId);
  const otherBets = currentBets.filter((bet) => bet.userId !== userId);
  const changedBets = (bets = []) => {
    return bets.reduce((acc, curr) => {
      const isFullCashOutedBetWithHalf = curr?.betData?.cashOutInfos?.length === 2;
      const onlyHalfCashOutedBet = curr?.betData?.cashOutInfos?.length === 1;

      return [
        ...acc.filter((item) => item?.id !== curr?.id),
        ...(isFullCashOutedBetWithHalf
          ? [
              { ...curr, ...curr?.betData.cashOutInfos[0] },
              { ...curr, ...curr?.betData.cashOutInfos[1] },
            ]
          : onlyHalfCashOutedBet
          ? [
              {
                ...curr,
                amount: divide(curr?.amount, 2),
                status: BetStatus.Pending,
                odd: 0,
                winAmount: 0,
              },
              {
                ...curr,
                id: createGuid(),
                amount: divide(curr?.amount, 2),
                status: BetStatus.Win,
                odd: curr.odd,
                winAmount: curr.winAmount,
              },
            ]
          : [curr]),
      ];
    }, []);
  };
  return [
    ...(myBets?.length ? changedBets(myBets) : []),
    ...(otherBets?.length ? changedBets(otherBets) : []),
  ];
};
